// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 164 ? "chart" : chunkId) + ".bundle.ac71065ae156b32c1f9cee04dc3e57eee5e2f0c0.js";
};